export const LabelUpgrade = () => {
  return <label className="nj-label-upgrade">UPGRADE</label>;
};
